import dedent from 'dedent';
import { z } from 'zod';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';

export type DesignLayout = z.infer<typeof layoutSchema>;

export type DesignType = z.infer<typeof typeSchema>;

export const layoutSchema = z.enum(['new', 'existing']);

export const typeSchema = z.enum([
  'postcard_half',
  'postcard_jumbo',
  'postcard_flats',
  'flyer_1',
  'flyer_2',
  'flyer_4',
  'brochure_8',
  'brochure_12',
  'brochure_16',
  'brochure_20',
  'brochure_24',
  'brochure_28',
  'brochure_32',
]);

export default createPerformableConfig(
  'design',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      layout: layoutSchema,
      type: typeSchema,
    }),
  },
  {
    name: 'Graphic Design',
    group: 'Property Marketing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/print/design.jpg',
    images: [],
    short: dedent`
      Our Graphic Design services create polished layouts for flyers and brochures. Get \
      high-resolution, print-ready files tailored to your brand. Need content? Our writers \
      can help for a small fee. With fast turnaround times, you’ll have professional materials \
      ready to print anytime.
    `,
  },
);
